import { map } from 'rxjs/operators';
import { MenuService } from './../../../theme/layout/admin/services/menu/menu.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MenuGuard implements CanActivate {

  constructor(private menuService: MenuService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const realUrl = state.url.split('?')[0];

    if (['/admin'].includes(realUrl)) {
        return true;
    }
    //reparar si se quiere usar bloqueo por menu
    return true
   /*  return this.menuService.hasAccess(realUrl).pipe(map(r => {
        if (r.hasAccess) {
            return true;
        } else {
            this.router.navigate(['/admin']);
            return false;
        }
    })); */
  }


}